import React from 'react'
import QbmPage from '../QbmPage'


const QuestionsPage = () => {
    return <QbmPage />
}

export default QuestionsPage


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/routes/QuestionsPage.js